import { Grid, GridItem, Modal, ModalSize, OParagraph, PrimaryButton } from '@lifechurch/react-ion';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import Imgix from 'react-imgix';

export interface Props {
  onDismiss: () => void;
  open: boolean;
  imageUrl: string;
  imageWidth?: number;
  infoText: string;
}

const InfoValuePropModal: FC<Props> = ({
  onDismiss,
  open,
  imageUrl,
  imageWidth = 240,
  infoText,
}) => {
  const { t } = useTranslation(['service_content', 'common']);

  return (
    <Modal dismiss={onDismiss} dismissible open={open} size={ModalSize.NARROW}>
      <Grid justifyItems={'center'}>
        <Imgix width={imageWidth} src={imageUrl} />
        <OParagraph textAlign={'center'} marginBlockStart={5}>
          {infoText}
        </OParagraph>
        <GridItem alignSelf={'center'}>
          <PrimaryButton onClick={onDismiss} marginBlockStart={5}>
            {t('okay')}
          </PrimaryButton>
        </GridItem>
      </Grid>
    </Modal>
  );
};

export default InfoValuePropModal;
